import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

export const Footer: React.FC<React.PropsWithChildren<any>> = () => {
  const { t } = useTranslation('translation');

  return (
    <footer className="footer">
      <Card className="border-bottom-0 text-center">
        <Card.Body className="p-2">
          {t('home.footer.beginning')}
          <a href={`mailto:${t('home.footer.mail')}`}>{t('home.footer.mail')}</a>
          {t('home.footer.end')}
          <Row className="m-0">
            <Col md="12">
              CSSF processes personal data you provide according to the GDPR (UE 2016/679) as detailed in our Privacy Policy published on
              the CSSF website :{' '}
              <a href="https://www.cssf.lu" target="_blank" rel="noopener noreferrer">
                www.cssf.lu
              </a>
              <br />
              <a href="https://www.cssf.lu/en/terms-of-service-and-privacy-policy/" target="_blank" rel="noopener noreferrer">
                Privacy Policy
              </a>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </footer>
  );
};
